import NotificationBar from 'components/notifications/NotificationBar';
import HttpService from 'services/HttpService';
import { onShowMoviePageView } from 'shared/braze_events/events';
import PreferencesTracking from 'components/preferences/PreferencesTracking';
import Braze from '../../shared/Braze';
import Highlight from '../highlight/Highlight';
import { dispatchCustomEvent } from '../highlight/helpers';

const brazeObj = new Braze();

export default class PreferencesCta {
    INITIALIZED_CLASS = 'initialized';
    WRAPPER_ELEMENT = '.content_preference_wrapper';
    static NOTIFY_ON_CLASS = 'notify_on';
    CTA_ELEMENT = '.contentPreferenceCta';
    static CTA_ERROR_COPY = "Oops! That didn't work. Please try again later.";
    static CTA_ERROR_NOTIFICATIONS_DISABLED_COPY =
        "Oops! That didn't work. Please enable site notifications and try again later.";
    NOTIFICATION_GRANTED = 'granted';
    WRAPPER_PARENT = '.cta-box';
    NOTIFICATION_NOT_SUPPORTED_CLASS = 'notification-ns';

    constructor(el) {
        this.container = el ?? null;
        this.cta = null;
        this._http = new HttpService();
        this.notificationService = window._notificationService;
        this._tracking = null;
        this.contentData = {};
        this.init();
    }

    init() {
        if (!PreferencesCta.browserIsNotificationCapable()) {
            this.massageCtaContainer();
            return false;
        }
        this.container = this.container
            ? this.container.querySelector(this.WRAPPER_ELEMENT)
            : document.querySelector(this.WRAPPER_ELEMENT);
        if (!this.container) return false;
        this._notificationBar = new NotificationBar();
        this.cta = this.container.querySelector(this.CTA_ELEMENT);
        this.contentData = { ...this.cta.dataset };
        this.contentData.notifyOn = this.contentData.notifyOn.toLowerCase() === 'true';
        this.container.classList.add(this.INITIALIZED_CLASS);

        this.cta.addEventListener('click', (event) => {
            event.preventDefault();

            brazeObj
                .requestBrowserNotificationPermission()
                .then(() => {
                    this.ctaClick();
                })
                .catch((err) => {
                    console.log('Notifications permission denied', err);
                });
        });

        CBS.Promises.Tracking.onLoad(() => {
            this._tracking = new PreferencesTracking(this.contentData, this.cta);
        });

        document.addEventListener(Highlight.STATE_CAROUSEL_EVENT_TYPE, () => {
            this.updateUi();
        });

        this.updateUi();
        this.triggerPageView();
    }

    async isNotificationOn() {
        while(!this.notificationService.loaded) {
            await new Promise((resolve) => setTimeout(resolve, 50));
        }

        return this.notificationService.isContentInNotificationList(this.contentData.contentId);
    }

    async updateUi() {
        if(await this.isNotificationOn()) {
            this.cta.classList.add(PreferencesCta.NOTIFY_ON_CLASS)
        } else {
            this.cta.classList.remove(PreferencesCta.NOTIFY_ON_CLASS);
        }
    }

    notifyOn() {
        let self = this;
        const url = this.contentData['contentAddUrl'];

        this.notificationService
            .addContentToNotificationList(
                this.contentData.contentId,
                `${CBS.Registry.region.prefix}${url}?title=${this.contentData['contentTitle']}`,
            )
            .then(({ data }) => {
                if (data.success) {
                    self.showToast(data.message, data.success);
                    dispatchCustomEvent(self.container, Highlight.STATE_CAROUSEL_EVENT_TYPE);
                    self._tracking.trackStateChangeAction(true);
                    self.updateUi();
                }
            })
            .catch((e) => {
                this.showToast(PreferencesCta.CTA_ERROR_COPY, false);
            });
    }

    notifyOff() {
        let self = this;
        const url = this.contentData['contentRemoveUrl'];
        
        this.notificationService
            .removeContentFromNotificationList(
                this.contentData.contentId,
                `${CBS.Registry.region.prefix}${url}?title=${this.contentData['contentTitle']}`,
            )
            .then(({ data }) => {
                if (data.success) {
                    self.showToast(data.message, data.success);
                    dispatchCustomEvent(self.container, Highlight.STATE_CAROUSEL_EVENT_TYPE);
                    self._tracking.trackStateChangeAction(false);
                    self.updateUi();
                }
            })
            .catch((e) => {
                self.showToast(PreferencesCta.CTA_ERROR_COPY, false);
            });
    }

    async ctaClick() {
        if (this._notificationBar.isVisible()) return false;

        if (Notification.permission !== this.NOTIFICATION_GRANTED) {
            this.showToast(PreferencesCta.CTA_ERROR_NOTIFICATIONS_DISABLED_COPY, false);
            return false;
        }

        if (!this.cta.classList.contains(PreferencesCta.NOTIFY_ON_CLASS)) {
            this.notifyOn();
        } else {
            this.notifyOff();
        }
    }

    showToast(message, success) {
        this._notificationBar.showMessage(message, success);
        this._notificationBar.setAutoHide(3000);
    }

    triggerPageView() {
        onShowMoviePageView(this.contentData.contentType, {
            triggerIAMNewContent: true,
            notificationEnabled: Notification.permission === this.NOTIFICATION_GRANTED,
        });
    }

    static browserIsNotificationCapable() {
        return typeof Notification !== 'undefined';
    }

    massageCtaContainer() {
        let breakElement = document.querySelector(this.WRAPPER_PARENT);
        if (typeof breakElement !== 'undefined')
            breakElement.classList.add(this.NOTIFICATION_NOT_SUPPORTED_CLASS);
    }
}
